module.exports = __webpack_public_path__ + "assets/img/icon-standard-map-blue.118c3e33.png";